module.exports = __webpack_public_path__ + "static/media/settings-icon-active.a982ef83.svg";